const ClaimBlock = ({ children }) => {
  return (
    <div className="flex-col md:flex-row w-[95%] md:w-[90%] mx-auto rounded-2xl p-6 md:p-0 flex gap-10 mb-10 mt-10 bg-white h-auto m-auto md:mb-auto md:mt-auto md:max-w-[1440px]  md:h-[90vh] md:max-h-[800px] box-shadow-block ">
      {children}
    </div>
  );
};

export default ClaimBlock;
